import { FetchRequiredOnboardingRequestTypes } from '../actions/RequiredOnboardingActions';
const initialState = {};
const RequiredOnboarding = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case FetchRequiredOnboardingRequestTypes.RECEIVE:
      {
        const {
          data
        } = payload;
        return data && data.requiredOnboarding;
      }
    default:
      return state;
  }
};
export default RequiredOnboarding;